import { useSnackbarStore } from '@/store/snackbarStore'
import i18n from '@/plugins/i18n/config'
import ResponseConstant from '@/constants/responseConstant'

export const displayToast = (message, color) => {
  useSnackbarStore().showSnackbar({ text: message, color: color })
}

export const handleResponseError = (error, toastType = 'error', isItech = false) => {
  if (!error) {
    displayToast(i18n.global.t('ERROR_STATUS_CODE_MESSAGE.UNKNOWN'), toastType)
    return
  }

  const response = error?.response
  const errorKey = response?.data?.key
  const errorParams = response?.data?.params
  const errorStatus = response?.status

  if (errorKey && errorKey in ResponseConstant) {
    displayToast(
      i18n.global.t('ERROR.' + ResponseConstant[errorKey], {
        params: errorParams !== undefined ? errorParams : null
      }),
      toastType
    )
  } else {
    const errorKey = isItech
      ? 'ERROR.ITECH_GENERIC_ERROR_KEY'
      : 'ERROR_STATUS_CODE_MESSAGE.' + (response ? errorStatus : 'UNKNOWN')

    displayToast(i18n.global.t(errorKey), toastType)
  }
}
